import { useEffect } from "react";
import { Box } from "@mui/material";
import Base from "../../Base/views/Base";
import GoalCategoryConfiguration from "./GoalCategory/GoalCategoryConfig";

const PerformanceSetting = () => {
  useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Base>
      <Box sx={{ height: "calc(100vh - 65px)", overflowY: "auto" }}>
        <GoalCategoryConfiguration />
      </Box>
    </Base>
  );
};

export default PerformanceSetting;
